import clsx from 'clsx'
import React from 'react'

interface buttonProps{
    className : string,
    type?: any,
    variant?: string,
    size: string,
    children: any,
    showLoading?: boolean,
    onClick?: () => void,
    disabled?: boolean
}

const Button = (props: buttonProps) => {
  return (
    <button
      type={props.type}
      className={
        props.className
          ? `btn d-inline-flex align-items-center ${props.size} ${props.className} `
          : "btn d-inline-flex align-items-center"
      }
      onClick={props.onClick}
    >
      {props.children ? `${props.children}` : "Button"}
      {props.showLoading && props.showLoading ? (
        <div className="loader active">
          <div className="splash-icon"></div>
        </div>
      ) : null}
    </button>
  );
}

export {Button}